import React from "react";

const OrdersIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="3" width="16" height="18" rx="2" stroke="currentColor" strokeWidth="1.7" />
      <path d="M8 8h8M8 12h8M8 16h5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <circle cx="17.5" cy="17.5" r="3.5" fill="currentColor" />
      <path d="M16.2 17.5h2.6M17.5 16.2v2.6" stroke="#fff" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  );
};

export default OrdersIcon;
